import styled from 'styled-components';
import { IonButton } from '@ionic/react';
import { MapToastsContainer } from '../../Global/DumbMap/subComponents/mapToastsStyles';

export const TraisOnMapContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 4rem;
`;

export const TrailsOnMapButton = styled(IonButton)`
	font-size: 0.875rem;
	svg {
		width: 16px;

		margin-right: 8px;
		path {
			fill: #fff;
		}
	}
`;

export const TrailMapContainer = styled.div`
	height: 70svh;
	margin-top: 60px;
	width: 100%;
	padding: 1rem;
`;

export const TrailMapToastsContainer = styled(MapToastsContainer)`
	bottom: 1rem;
	padding: 0 1rem;
`;
